<template>
  <base-layout
    :readOnly="readOnly"
    :value="value"
    :label-width="labelWidth"
    :text-align="textAlign"
    :style-type="styleType"
    :is-require="isRequire"
    :label="label"
    :is-dipatch="isDipatch"
    :is-dipatch-style="isDipatchStyle"
    :labelPaddingRight = "labelPaddingRight"
    :whiteSpace="whiteSpace"
    :isWrap="isWrap"
  >
    <el-input
      :clearable="true"
      :suffix-icon="icon"
      @blur="handleEmitBlur"
      @keyup.enter.native="handleEmitEnter"
      @change="handleEmitEnter"
      :type="type"
      :rows="rows"
      slot="control"
      :autofocus="autofocus"
      :disabled="disabled"
      @input="handleEmitValue"
      v-model="inputValue"
      :placeholder="placeholder"
      :min="min"
      :max="max"
      ref="input"
    >
      <i v-if="multiple" @click="handleInnerIconClick" slot="suffix" class="el-input__icon el-icon-menu"></i>
    </el-input>
    <multiline-dialog
      slot="dialog"
      :title="title ? title : '批量修改'"
      ref="multiline-dialog"
      size="small"
      :modal="modal"
      @handleSave="handleDialogSave"
    >
      <base-string type="textarea" v-model="dialogConfig.value"></base-string>
    </multiline-dialog>
  </base-layout>
</template>

<script>
import baseLayout from "./base-layout.vue";
import {
  handleEmitValue,
  string,
  handleEmitBlur,
  handleEmitEnter
} from "./../props-config";
import Vue from "vue";
export default {
  name: "base-string",
  components: {
    baseLayout
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        if (this.isDipatch) {
          this.$store.dispatch("updateObject", {
            obj: this.dipatchObj,
            attr: this.dipatchAttr,
            val: val
          });
        }
        this.$emit("input", val);
      }
    }
  },
  props: {
    ...string,
    type: {
      type: String,
      default: "text"
    },
    handleIconCLick: {
      type: Function,
      default: () => {}
    },
    multiple: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    min: {
      type: Number
    },
    max: {
      type: Number
    },
    whiteSpace: {
      type: Boolean
    },
    isWrap: {
      type: Boolean
    }
  },
  mounted() {},
  methods: {
    handleDialogSave() {
      const val = this.dialogConfig.value.split(/[(\r\n)\r\n\↵]+/).join(",");
      this.$emit("input", val);
      if (this.isDipatch) {
        this.$store.dispatch("updateObject", {
          obj: this.dipatchObj,
          attr: this.dipatchAttr,
          val: val
        });
      }
      this.$refs["multiline-dialog"].handleIsShow(false);
    },
    handleInnerIconClick() {
      console.log(this.$refs);
      this.dialogConfig.value = this.value;
      this.$refs["multiline-dialog"].handleIsShow(true);
    },
    handleFocus() {
        this.$refs['input'].$el.children[1].focus()
    },
    handleEmitValue,
    handleEmitBlur,
    handleEmitEnter
  },
  data() {
    return {
      dialogConfig: {
        value: ""
      },
      _emit: null
    };
  }
};
</script>
